import React, { useState, useEffect, useRef } from "react";

interface Props {
  text: string;
}

const DescriptionMoreLess=({ text }:any) => {
  const [expanded, setExpanded] = useState(false);
  const [isOverflowed, setIsOverflowed] = useState(false);
  const textRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      setIsOverflowed(el.scrollHeight > el.clientHeight + 1);
    }
  }, [text]);

  return (
    <div className="clamp-container cardDesciption">
      <div
        className={`more-less-clamp-text ${expanded ? "more-less-expanded" : "more-less-clamped"}`}
        ref={textRef}
      >
        {text}  {expanded && <button className="more-less-clamp-toggle theme-text-color" onClick={() => setExpanded(!expanded)}>
          {expanded ? "less" : "more"}
        </button>}
      </div>

      {isOverflowed && !expanded && (
        <button className="more-less-clamp-toggle theme-text-color" onClick={() => setExpanded(!expanded)}>
          {expanded ? "less" : "more"}
        </button>
      )}
    </div>
  );
};

export default DescriptionMoreLess;
